<template>
    <b-card v-if="rows.length" border-variant="light" no-body>
        <b-card-header>
            <b-card-title class="mb-0">{{ $t('Component(RegulatedProductStatementDeclaration):label') }}</b-card-title>
        </b-card-header>
        <b-table-simple responsive class="mb-0">
            <b-thead>
                <b-tr>
                    <b-th>{{ $t('Component(Grid):column-title') }}</b-th>
                    <b-th>{{ $t('Component(Grid):column-covered-excluded') }}</b-th>
                    <b-th>{{ $t('Component(Label):comment') }}</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="row in rows" :key="row.statementId">
                    <b-td>
                        {{ row.title }}
                        <div v-for="source in row.sources" :key="source.productId" class="mt-1">
                            <span class="text-muted">{{ sourceLabel }}:</span>
                            <b-link :to="{ name: 'product-card', params: { id: source.productId } }" target="_blank">
                                #{{ source.productId }}
                            </b-link>
                        </div>
                    </b-td>
                    <b-td>
                        <b-form-radio-group
                            :checked="row.answer"
                            :options="answerOptions"
                            :disabled="disabled || row.canEditAnswer !== true"
                            :aria-label="row.title"
                            @change="change(row, 'answer', $event)"
                        />
                    </b-td>
                    <b-td>
                        <b-form-textarea
                            :value="row.comment"
                            :disabled="disabled || row.canEditComment !== true"
                            :aria-label="`${row.title}: ${$t('Component(Label):comment')}`"
                            :maxlength="32000"
                            rows="2"
                            max-rows="8"
                            @input="change(row, 'comment', $event === '' ? null : $event)"
                        />
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </b-card>
</template>

<script>
import {
    BCard, BCardHeader, BCardTitle, BTableSimple, BThead, BTbody, BTr, BTh, BTd,
    BFormRadioGroup, BFormTextarea, BLink,
} from 'bootstrap-vue'

export default {
    name: 'ProductStatementAnswers',
    components: {
        BCard, BCardHeader, BCardTitle, BTableSimple, BThead, BTbody, BTr, BTh, BTd,
        BFormRadioGroup, BFormTextarea, BLink,
    },
    props: {
        rows: { type: Array, default: () => [] },
        disabled: { type: Boolean, default: false },
    },
    computed: {
        sourceLabel() {
            const key = 'Component(ProductStatementAnswers):source'
            const value = this.$t(key)
            if (value !== key) return value
            return this.$i18n && this.$i18n.locale === 'sv' ? 'Källa' : 'Source'
        },
        answerOptions() {
            return [
                { text: this.$t('Component(Choice):yes'), value: true },
                { text: this.$t('Component(Choice):no'), value: false },
                { text: this.$t('Component(Choice):not_answered'), value: null },
            ]
        },
    },
    methods: {
        change(row, field, value) {
            const editable = field === 'answer' ? row.canEditAnswer : row.canEditComment
            if (!this.disabled && editable === true) {
                this.$emit('change', { statementId: row.statementId, field, value })
            }
        },
    },
}
</script>

